import React, { useState, useEffect } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { useApolloClient } from '@apollo/client';
import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { Receipt, Logout, Payment, ContactSupport, PersonOutline, Dashboard } from '@mui/icons-material';

// assets
import { useNavigate } from 'react-router-dom';
import { useAuthenticator } from '@aws-amplify/ui-react';
import { fetchAuthSession } from 'aws-amplify/auth';
import { logger } from '../../../../../../utils/logger';

// ==============================|| HEADER PROFILE - PROFILE TAB ||============================== //

const ProfileTab = () => {
    const theme = useTheme();
    const client = useApolloClient();
    const { user } = useAuthenticator((context) => [context.user]);
    const [userGroup, setUserGroup] = useState('');

    useEffect(() => {
        const getUserGroup = async () => {
            try {
                const session = await fetchAuthSession();
                const groups = session.tokens?.idToken?.payload?.['cognito:groups'];
                setUserGroup(Array.isArray(groups) && groups.length > 0 ? groups[0] : '');
            } catch (e) {
                logger.log('Error fetching user group:', e);
            }
        };
        if (user) {
            getUserGroup();
        }
    }, [user]);

    const { signOut } = useAuthenticator((context) => [context.route, context.signOut]);
    const navigate = useNavigate();
    const ownerPermissions = userGroup === 'Owner' || userGroup === 'Free';
    const adminPermissions = userGroup === 'Admin';
    function logout() {
        client.cache.reset();
        client.clearStore();
        localStorage.clear();
        sessionStorage.clear();
        signOut();
        navigate('/login');
    }

    function billing() {
        navigate('/billing');
    }

    function support() {
        navigate('/support');
    }

    function plan() {
        navigate('/plans');
    }

    function account() {
        navigate('/account');
    }

    function dashboard() {
        navigate('/dashboard/default');
    }

    return (
        <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32, color: theme.palette.grey[500] } }}>
            <ListItemButton onClick={dashboard}>
                <ListItemIcon>
                    <Dashboard />
                </ListItemIcon>
                <ListItemText primary="Dashboard" />
            </ListItemButton>
            <ListItemButton onClick={account}>
                <ListItemIcon>
                    <PersonOutline />
                </ListItemIcon>
                <ListItemText primary="Account" />
            </ListItemButton>
            {(ownerPermissions || adminPermissions) && (
                <ListItemButton onClick={plan}>
                    <ListItemIcon>
                        <Receipt />
                    </ListItemIcon>
                    <ListItemText primary="Plan" />
                </ListItemButton>
            )}
            {(ownerPermissions || adminPermissions) && (
                <ListItemButton onClick={billing}>
                    <ListItemIcon>
                        <Payment />
                    </ListItemIcon>
                    <ListItemText primary="Billing" />
                </ListItemButton>
            )}
            <ListItemButton onClick={support}>
                <ListItemIcon>
                    <ContactSupport />
                </ListItemIcon>
                <ListItemText primary="Support" />
            </ListItemButton>
            <ListItemButton onClick={logout}>
                <ListItemIcon>
                    <Logout />
                </ListItemIcon>
                <ListItemText primary="Logout" />
            </ListItemButton>
        </List>
    );
};

export default ProfileTab;
